// extracted by mini-css-extract-plugin
export default {"block":"GeneralBlock_block__5AuQ8","avatarWrap":"GeneralBlock_avatarWrap__ZQL4J"};